import styled from "styled-components"

export const Li = styled.li`
  list-style: none;
  padding: 0;
  padding-inline-start: 0;
  margin: 0;
`

export default Li
